module.exports = __webpack_public_path__ + "static/media/purchace_status.2baf410f.svg";